import { Component, inject, input } from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop';
import { KENDO_GRID } from '@progress/kendo-angular-grid';
import { AbstractGridComponent } from '@unity/abstract/abstract-grid.component';
import { AgencyUserDetailedDto, AgencyUsersClient } from '@unity/clients';
import { AuthorizeDirective } from '@unity/directives/authorize.directive';
import { TypedDirective } from '@unity/directives/typed.directive';
import { GridSharedComponent } from '@unity/shared/composed/grid-shared/grid-shared.component';
import { ChipWorkflowStateSharedComponent } from '@unity/shared/presentation/chip-workflow-state-shared/chip-workflow-state-shared.component';
import { LinkGridcellSharedComponent } from '@unity/shared/presentation/link-gridcell-shared/link-gridcell-shared.component';
import { LinkMailtoSharedComponent } from '@unity/shared/presentation/link-mailto-shared/link-mailto-shared.component';
import { SortConfig } from '@unity/utils/types';

@Component({
  selector: 'unity-grid-agency-user-shared',
  standalone: true,
  imports: [
    KENDO_GRID,
    AuthorizeDirective,
    ChipWorkflowStateSharedComponent,
    LinkMailtoSharedComponent,
    GridSharedComponent,
    LinkGridcellSharedComponent,
    TypedDirective,
  ],
  templateUrl: './grid-agency-user-shared.component.html',
  styleUrl: './grid-agency-user-shared.component.scss',
})
export class GridAgencyUserSharedComponent extends AbstractGridComponent<AgencyUserDetailedDto> {
  private readonly agencyUsersClient = inject(AgencyUsersClient);

  protected readonly resource = rxResource({
    params: () => {
      const query = this.$gridifyQuery();
      const agencyId = this.$agencyId();
      return query && agencyId ? { query, agencyId } : undefined;
    },
    stream: ({ params: { agencyId, query } }) =>
      this.agencyUsersClient.getAllAsDetailed(agencyId, query.page, query.pageSize, query.orderBy, query.filter),
  });

  public readonly $agencyId = input.required<number>({ alias: 'agencyId' });

  protected defaultSort: SortConfig[] = [
    {
      field: 'fullname',
      dir: 'asc',
    },
  ];
}
